export const validationConstants = {
    'string': 'StringValidator',
    'date' : 'DateValidator'    
  };
  